module.exports = __webpack_public_path__ + "static/img/category4v.24f8351.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/category4v.jpg
// module id = 1UjD
// module chunks = 0